import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: ""
  },
  mutations: {
    // setToken(params) {
    //   console.log("params" + params);
    // }
  },
  actions: {
    setToken(context, params) {
      this.state.token = params;
    }
  },
  modules: {}
});
